import { AppPaths } from "@p0security/shared/routes/constants";
import { AgenticClientsProvider } from "components/Agentic/AgenticClientsContext";
import { Page } from "components/App/Page";
import { useFlags } from "launchdarkly-react-client-sdk";
import { Navigate, Route, useLocation, useParams } from "react-router";

import { Jit } from "./Jit";
import { ActivePreApproval } from "./Requests/pages/ActivePreApprovalPage";
import { ActiveRequests } from "./Requests/pages/ActiveRequestsPage";
import { RequestHistory } from "./Requests/pages/RequestHistory";
import { JitPaths } from "./paths";

const JitLegacyRedirect = () => {
  const { orgSlug } = useParams();
  const { pathname, search, hash } = useLocation();
  const destination = pathname.replace(
    `/o/${orgSlug}/jit`,
    `/o/${orgSlug}/${AppPaths.AccessManagement}`
  );
  return <Navigate to={`${destination}${search}${hash}`} replace />;
};

export const JitRoutes = () => {
  const flags = useFlags();
  return (
    <>
      <Route
        path={AppPaths.AccessManagement}
        element={
          <AgenticClientsProvider>
            <Jit />
          </AgenticClientsProvider>
        }
      >
        <Route index element={<Navigate to="activity" replace />} />
        <Route
          path={JitPaths.Activity}
          element={
            <Page title={"Access Management Activity"}>
              <ActiveRequests />
            </Page>
          }
        >
          <Route path=":requestId" element={<></>} />
        </Route>
        {flags.showEvidenceStore && (
          <Route
            path={JitPaths.PreApprovals}
            element={
              <Page title={"Pre Approvals"}>
                <ActivePreApproval />
              </Page>
            }
          />
        )}
        <Route
          path={JitPaths.History}
          element={
            <Page title={"Access Management History"}>
              <RequestHistory />
            </Page>
          }
        >
          <Route path=":requestId" element={<></>} />
        </Route>
      </Route>
      <Route path="jit/*" element={<JitLegacyRedirect />} />
    </>
  );
};
